'use strict';

angular.module('webAgro1App').factory('NotificacoesService', function($http) {
  return {
    list: function() {
      return $http.get(`${SERVER }v1/notificacoes`);
    }
  };
});
